import { CustomPropertyAttribute } from '../../../types/CustomPropertyAttribute';

const sanitizeLabel = (label: string) => {
  return label
    .replace(/[^\w ]/g, '') // Removes any character other than letters, digits, spaces and underscores
    .trim() // Trim the resulting string
    .replace(/ +/g, '_') // Converts any spaces to underscores
    .replace(/_+/g, '_') // Removes multiple underscores in sequence
    .slice(0, 30) // Limits slug to 30 characters
    .replace(/^_+|_+$/g, '') // Trim underscores from resulting string
    .toLowerCase(); // Makes slug lowercase
};

export const createSlugFromLabel = (
  label: string,
  allAttributes: CustomPropertyAttribute[]
) => {
  const separator = '__';
  const labelAsSlug = sanitizeLabel(label);
  const existingSlugs = allAttributes.filter(
    ({ slug }) =>
      slug === labelAsSlug || slug.startsWith(`${labelAsSlug}${separator}`)
  );
  const suffix =
    existingSlugs.length > 0 ? `${separator}${existingSlugs.length + 1}` : '';
  return `${labelAsSlug}${suffix}`;
};
